<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("support.qna.qnaWrite") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl">
        <tbody>
          <tr>
            <th style="padding-left: 30px">{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                id="title"
                name="title"
                v-validate="'required'"
                v-model="qna.title"
                class="form-control text"
              />
            </td>
          </tr>
          <tr>
            <th style="padding-left: 30px">{{ $t("common.file") }}</th>
            <td>
              <uploader
                :options="options"
                class="uploader-example"
                :autoStart="false"
                :size="10"
                @file-added="filesAdded"
                @file-removed="fileRemoved"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <uploader-btn>Select or drag&drop file</uploader-btn>
                </uploader-drop>
                <uploader-list></uploader-list>
              </uploader>
              <div class="view_file" v-if="files.length > 0 && files != null">
                <ul>
                  <li>
                    <a v-for="(file, index) in files" :key="index" href="#">
                      {{ file.fileNm }}
                      <button @click="deleteFile(file)" class="del_bt">Del</button>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <th style="padding-left: 30px">{{ $t("common.classify") }}</th>
            <td>
              <select
                id="searchClass"
                v-model="qna.classId"
                class="m-1 form-control"
                v-validate="'required'"
              >
                <option value="">--{{ $t("support.qna.selectClassification") }}--</option>
                <option
                  v-for="(clazz, index) in classList"
                  :key="index"
                  :value="clazz.classId"
                >
                  {{ clazz.className }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                class="textarea_type"
                name="content"
                v-validate="'required'"
                v-model="qna.content"
                :config="editorConfig"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <button type="button" @click="goQnaList" class="btn btn-outline-dark btn-lg m-1">
          {{ $t("common.list") }}
        </button>
        <button type="button" @click="saveQna" class="btn btn-primary btn-lg">
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { getQna, insertQna, getUserQnaClsList } from "@/api/qna";
import { deleteFile } from "@/api/file";

export default {
  data() {
    return {
      qna: { qnaFiles: [], flag: "I", classId: "" },
      editorConfig: {
        filebrowserImageUploadUrl: "/img/fileupload",
        filebrowserUploadMethod: "form",
      },
      files: [],
      classList: [],
      boardId: "",
      // 파일업로더 옵션1
      options: {
        testChunks: false,
        chunkSize: "10", //Block size
        maxChunkRetries: 3,
      },
      // 파일업로더 옵션2
      statusText: {
        success: "완료",
        error: "에러",
        uploading: "업로드중",
        paused: "일시중지",
        waiting: "대기중",
      },
      newFiles: [],
      refuseFileType: [
        "asp",
        "aspx",
        "jsp",
        "php",
        "inc",
        "cgi",
        "html",
        "htm",
        "js",
        "jar",
        "jhtml",
        "php3",
        "phtml",
        "exe",
        "dll",
      ],
    };
  },
  mounted() {
    this.getQnaCls();
    if (this.$route.params.boardId != null) {
      this.fetchData();
    }
  },
  methods: {
    async getQnaCls() {
      try {
        const { data } = await getUserQnaClsList();
        this.classList = data.qaClsList;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchData() {
      // qna list 불러오기 검색시 동일
      // 질문 글
      try {
        this.boardId = this.$route.params.boardId;
        const response = await getQna(this.boardId);
        this.qna = response.data.qna;
        this.qna.flag = "U";
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
    },
    async saveQna() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        // 파일 formData 추가
        const formData = new FormData();
        formData.append("title", this.qna.title);
        formData.append("classId", this.qna.classId);
        formData.append("content", this.qna.content);
        formData.append("flag", this.qna.flag);
        formData.append("boardId", this.boardId);
        formData.append("state", "N");
        if (this.newFiles != null && this.newFiles != "") {
          for (var i = 0; i < this.newFiles.length; i++) {
            let file = this.newFiles[i];
            formData.append("qnaFiles", file);
          }
        }
        const { data } = await insertQna(formData);
        if (data.fileMessage != null && data.message != null) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        } else if (data.fileMessage == null && data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.$store.commit("setComponentName", "Q&A");
          if (
            this.boardId == null ||
            this.boardId == "" ||
            this.boardId == undefined ||
            this.boardId == "undefined"
          ) {
            this.$router.push({ name: "qnaList" });
          } else {
            this.$router.push({ name: "qnaDetail", query: { boardId: this.boardId } });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteFile(file) {
      if (!confirm(this.$t("alert.delete"))) return;
      try {
        const { data } = await deleteFile(file);
        if (data.status) {
          this.qna = "";
          this.files = [];
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPleasecontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    filesAdded(file) {
      let tmp = file.file.name;
      let fileName = tmp.split(".");
      // 파일 확장자 확인
      for (let i in this.refuseFileType) {
        if (fileName[fileName.length - 1] == this.refuseFileType[i]) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
          file.ignored = true;
          return;
        }
      }
      this.newFiles.push(file.file);
    },
    fileRemoved(file) {
      if (this.newFiles.length > 0) {
        for (let i = 0; i < this.newFiles.length; i++) {
          if (this.newFiles[i].name == file.file.name) {
            this.$delete(this.newFiles, i);
          }
        }
      }
    },
    goQnaList() {
      this.$store.commit("setComponentName", "Q&A");
      this.$router.push({ name: "qnaList" });
    },
  },
};
</script>

<style></style>
